import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { GotoInteractionAction } from '../../../../../../models/interactions.model';
import { FlowActionCardComponent } from '../flow-action-card/flow-action-card.component';

@Component({
  selector: 'app-flow-goto-interaction-action',
  imports: [FlowActionCardComponent, MatIconButton, MatIconModule, MatTooltip],
  templateUrl: './flow-goto-interaction-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowGotoInteractionActionComponent {
  readonly data = input.required<GotoInteractionAction>();
  /** Resolved first-question node ID for this interaction. Null if not yet loaded. */
  readonly targetNodeId = input<string | null>(null);
  readonly panToNode = output<string>();

  protected readonly label = computed(() => {
    const v = this.data()?.value as any;
    if (typeof v === 'object' && v !== null && v.label) {
      return v.label;
    }
    return typeof v === 'string' ? v : '';
  });

  protected readonly version = computed(() => {
    const v = this.data()?.value as any;
    if (typeof v === 'object' && v !== null && v.version !== undefined) {
      return v.version;
    }
    return null;
  });
}
